import { supabase } from './supabase'
import { dayKey } from '../utils/subscription'

/**
 * İşletmenin abonelik ödeme durumu (supabase/abonelik-kilit.sql): ödeme günü
 * ve salt okunur olacağı gün. Tutar yok, yalnız tarihler. Son okunan cihazda
 * saklanıyor: internetsiz açılan kasa da kilitli olduğunu bilsin.
 */
export interface PayStatus {
  /** Ödeme günü; kapanmayacak işletmede null. */
  dueOn: string | null
  /** Bu günden itibaren salt okunur; kapanmayacak işletmede null. */
  lockedSince: string | null
}

const key = (t: string) => `adissoo:pay:${t}`

export function cachedPayStatus(tenantId: string): PayStatus | null {
  try {
    const raw = localStorage.getItem(key(tenantId))
    return raw ? (JSON.parse(raw) as PayStatus) : null
  } catch {
    return null
  }
}

export async function fetchPayStatus(tenantId: string): Promise<PayStatus | null> {
  if (!supabase) return null
  const { data, error } = await supabase.rpc('tenant_pay_status', { t: tenantId })
  // Fonksiyon henüz yoksa ya da ağ yoksa son bilinen durum kalır.
  if (error || !data) return cachedPayStatus(tenantId)
  const out: PayStatus = { dueOn: data.dueOn ?? null, lockedSince: data.lockedSince ?? null }
  try {
    localStorage.setItem(key(tenantId), JSON.stringify(out))
  } catch {
    /* depolama dolu */
  }
  return out
}

export const isPayLocked = (s: PayStatus | null, now = new Date()) =>
  !!s?.lockedSince && dayKey(now) >= s.lockedSince

/** Ödeme günü geçti ama henüz kapanmadı. */
export const isPayLate = (s: PayStatus | null, now = new Date()) =>
  !!s?.dueOn && dayKey(now) > s.dueOn && !isPayLocked(s, now)
